import axios from 'axios';

export const CUSTOM_TYPOGRAPHY = 'v3/custom_fonts';

export function getCustomTypography() {
  return axios.get(CUSTOM_TYPOGRAPHY);
}
